<template lang="pug">
  include ./../../../mixins
  div
    router-module()
    +b.section--login
      +b.withdraw--created
        +b.ma--b_1md.TEXT-BEMTO(
          :fw="'bold'"
          :lh="'initial'"
          :fs="'4xl'"
          :color="'black'"
          :tag="'p'"
        ) Create New Order
        validation-observer(
          ref="observer"
          tag="form"
          class="form"
        )
          +b.ug-row--apearance_spaced.--space_md
            +b.ug-cell.ug-cols--12.--6-md
              +b.control-cabinet
                +e.label Date at
                +b.ug-row--apearance_spaced.--space_md.--align_end
                  +b.ug-cell.ug-cols--12.--6-md
                    validation-provider(
                      v-slot="{errors}"
                      rules="required"
                      name="date"
                    )
                      +b.control-cabinet.--centered
                        +e.element--centered.FLAT-PICKER(
                          v-model='dateAt.date', :config="cfgDate",
                          placeholder='DD/MM/YYYY',
                          type="date",
                          name="date"
                        )
                        +e.flat-toggle(
                          title="toggle"
                          data-toggle
                        )
                          +b.icon--type_date.I
                        +b.control-descriptor__errors {{ errors[0] }}
                  +b.ug-cell.ug-cols--12.--6-md
                    +b.control-cabinet.--centered
                      +e.element--centered.FLAT-PICKER(
                        v-model='dateAt.time', :config="cfgTime",
                        placeholder='HH:MM K',
                        type="date",
                        :disabled="!dateAt.date.length"
                      )
                      +e.flat-toggle(
                        title="toggle"
                        data-toggle
                      )
                        +b.icon--type_time.I
            +b.ug-cell.ug-cols--12.--6-md
              +b.input.D-CONTROL-INPUT(
                v-model="formData.phone"
                :input-label="'Phone number *'"
                :placeholder="'Phone number *'"
                :rules="'required|ukPhone'"
                :name="'phone'"
                :type="'tel'"
                id="phone"
              )
            +b.ug-cell.ug-cols--12.--6-md
              +b.input.D-CONTROL-INPUT(
                v-model="formData.price"
                :input-label="'Price *'"
                :placeholder="'Price *'"
                :rules="'required'"
                :name="'price'"
                :type="'number'"
                id="price"
              )
            +b.ug-cell.ug-cols--12.--6-md
              +b.control-cabinet
                +e.label Prepayment
                +e.element--centered {{ formData.prepayment || '-'}}
            +b.ug-cell.ug-cols--12.--6-md
              +b.input.D-CONTROL-INPUT(
                v-model="formData.carRegistration"
                :input-label="'Car Registration Number'"
                :placeholder="'Car Registration Number'"
                :name="'carRegistration'"
                :type="'text'"
                id="carRegistration"
              )
            +b.ug-cell.ug-cols--12.--6-md
              +b.postal-wrapper
                +b.input.D-CONTROL-INPUT(
                  v-model="formData.postCode"
                  :input-label="'Postal Code'"
                  :placeholder="'Postal Code'"
                  :name="'postCode'"
                  :type="'text'"
                  id="postCode"
                )
                +e.action--label(
                  @click.prevent="getLocationHandler"
                )
                  img(
                    src="/static/img/postcode.png"
                    alt="postcode"
                  )
            +b.ug-cell.ug-cols--12.--6-md
              +b.control-cabinet
                +e.label Responsible
                +e.element--centered {{ responsible.name || '-'}}
            +b.ug-cell.ug-cols--12.--6-md
              +b.D-CONTROL-OPTION(
                v-if="servicesItems.length"
                v-model="formData.service"
                :object-list="servicesItems"
                :input-label="'Choose a service you need *'"
                :placeholder="'Choose a service you need *'"
                :rules="'required'"
                :name="'service'"
                id="service"
              )
            +b.ug-cell.ug-cols--12
              +b.ug-row--apearance_spaced.--space_md.--justify_end
                +b.ug-cell.ug-cols--12.--6-md
                  +b.button--height_xl.BUTTON-BEMTO(
                    :disabled="isRequest"
                    @event="preperedBeforeAPI()"
                  )
                    +e.load.IMG(
                      src="/static/load.gif"
                      v-if="isRequest"
                    )
                    +e.text(
                      v-if="!isRequest"
                    ) BOOK NOW!
</template>

<script>
import FormMixin, { defaultValidatorErrorsParser } from '@/js/mixins/FormMixin'
import ToggleModalMixin from '@/js/mixins/ToggleModalMixin'

import {
  getServicesAPI,
  postCreateOrderAPI,
  getResponsibleAPI,
} from '@/js/services/cabinet'

import {
  asyncForEach,
} from '@/js/scripts/helpers'

const FULL = 100
const INIT = 1

export default {
  name: 'NewOrderCabinet',
  mixins: [
    FormMixin,
    ToggleModalMixin,
  ],
  props: {
    objectItem: {},
  },
  watch: {
    'formData.price': {
      immediate: true,
      deep: true,
      handler(val) {
        if (val) {
          const prepayment = this.prepayment * val / FULL
          this.formData.prepayment = Math.round(prepayment)
        } else {
          this.formData.prepayment = null
        }
      },
    },
    'dateAt.date': {
      immediate: true,
      deep: true,
      handler(val) {
        if (!val.length) {
          this.dateAt.time = ''
        }
      },
    },
  },
  data() {
    return {
      /** */
      cfgDate: {
        dateFormat: 'd/m/Y',
        allowInput: true,
        wrap: true,
      },
      /** */
      cfgTime: {
        dateFormat: 'h:i K',
        enableTime: true,
        noCalendar: true,
        allowInput: true,
        wrap: true,
      },
      dateAt: {
        date: '',
        time: '',
      },
      formData: { ...this.objectItem },
      responsible: {},
      prepayment: window.prepayment,
      servicesItems: [],
      isRequest: false,
    }
  },
  created() {
    // this.getSessionStorageHandler()
    this.getResponsibleAPI()
    this.getServicesAPI()
  },
  methods: {
    getSessionStorageHandler() {
      if (this.objectItem) {
        sessionStorage.setItem('formdata_no', JSON.stringify(this.formData))
      } else {
        const obj = sessionStorage.getItem('formdata_no')
        if (obj) {
          this.formData = JSON.parse(obj)
        }
      }
    },
    getResponsibleAPI() {
      return getResponsibleAPI.execute({})
        .then(response => {
          this.responsible = response.data.item
        })
    },
    getServicesAPI() {
      return getServicesAPI.execute({})
        .then(response => {
          this.servicesItems = response
        })
    },
    setCurrentPosition(option) {
      let lng = position.coords.longitude
      let lat = position.coords.latitude
      let key = window.googleApiKey
      let url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${key}`

      axios.get(url).then(response => {
        let results = response.data.results
        let addressComponents = results[0]['address_components']

        addressComponents.forEach(el => {
          if (el.types.includes('postal_code')) {
            this.formdata['post_code'] = el['long_name']
          }
        })
      })
    },
    getLocationHandler() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(this.setCurrentPosition)
      } else {
        this.toggleToster(
          'Sorry, but Geolocation is not supported by this browser.'
        )
      }
    },
    /**
     * Let's pre-format our form state.
     */
    async preperedBeforeAPI() {
      /**
       * Create the correct format for sending the date
       * and time to the server.
       */
      const DATETIME = {
        'date_at': `${this.dateAt.date} ${this.dateAt.time}`,
      }
      /**
       * The task is not to send only the time to the server,
       * the date is also required, so we will delete
       * the keys in which there is no date, so as not
       * to send them.
       */
      await asyncForEach(
        Object.keys(DATETIME), async key => {
          /**
           * The some () method checks if any element of
           * the array satisfies the condition specified
           * in the passed function.
           */
          if (DATETIME[key].length <= INIT) {
            delete DATETIME[key]
          }
        }
      )

      const OPTIONS = {
        responsible: this.responsible,
        ...this.formData,
        ...DATETIME
      }
      console.log(OPTIONS)
      OPTIONS.responsible = OPTIONS.responsible.id

      if (Object.keys(OPTIONS).includes('id')) {
        OPTIONS.request = OPTIONS.id
        delete OPTIONS['id']
      } else {
        delete OPTIONS['request']
      }

      this.validateBeforeSubmit(
        OPTIONS,
      )
    },
    /**
     * Submission handler, if validated.
     * @param { Object } data - Send data.
     */
    async send(data) {
      return postCreateOrderAPI.execute(
        {}, data
      )
        .then(response => {
          const OPTIONS = {
            phone: response.data.item.phone,
            message: response.data.item.link,
            link: response.data.item.link,
          }
          this.$router.push({
            name: 'CreateOrderCabinet',
            params: { objectItem: OPTIONS }
          })
        })
    },
    /**
     * After > error display normalization >
     * Set Observer errors.
     *
     * @param { Object } errors - Formatted errors
     */
    setErrors(errors) {
      const error = defaultValidatorErrorsParser(errors)
      this.$refs.observer.setErrors(error)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/js/components/Pages/Cabinet/NewOrderCabinet.vue